import { useEffect } from 'react';
import { MESSAGE_TYPE, MessageT } from '../types/ExtMessage';
import { useStore } from '../store/store';

export const useSyncChromeStorage = () => {
	const { setSelectedSourceLocale, setSelectedTargetLocale, updateSelectedConsumer, setTextBefore, setInitialTextToTranslate } = useStore((state) => state);

	useEffect(() => {
		window.addEventListener("message", async (event: MessageEvent<MessageT>) => {
			const message = event.data;
			if (message.type == MESSAGE_TYPE.getChromeStorageDataResponse) {
				const extensionData = message.data;
				if (extensionData) {
					if (extensionData.selectedConsumerId && extensionData.selectedConsumerName) {
						updateSelectedConsumer({
							id: extensionData.selectedConsumerId,
							name: extensionData.selectedConsumerName
						});
					}
					if (extensionData.selectedSourceLocale) {
						setSelectedSourceLocale(extensionData.selectedSourceLocale);
					}
					if (extensionData.selectedTargetLocale) {
						setSelectedTargetLocale(extensionData.selectedTargetLocale);
					}
				}
			}

			if ((message.type == MESSAGE_TYPE.nextActionResponse || message.type == MESSAGE_TYPE.nextActionUpdated)) {
				const text = message.data?.text;
				if (text) {
					setTextBefore(text);
					setInitialTextToTranslate(text);
					window?.top?.postMessage({type: MESSAGE_TYPE.clearNextAction}, "*");
				}
			}

		});
		window?.top?.postMessage({type: MESSAGE_TYPE.getChromeStorageData}, "*");
		window?.top?.postMessage({type: MESSAGE_TYPE.getNextAction}, "*");

	}, []);
}
